import { Injectable } from "@angular/core";
import { CanActivate, Router } from "@angular/router";
import { map } from "rxjs/operators";
import { descryptValue, encryptStorage } from "../utils/storage";

@Injectable({
  providedIn: "root",
})
export class AuthGuardService implements CanActivate {
  constructor(private route: Router) {}

  canActivate() {
    if (descryptValue('@user') == null || descryptValue('@user') == "") {
      this.route.navigate(["/home"]);
      return false;
    } else return true;
  }
}
